import { IOnboardingDocuments } from '@efex-services/documents/documentsSvc';
import {
  IDocumentUsaTypeId,
  OnboardingUsaDocumentTypeIds,
} from '@efex-services/documents/types';
import { GovermentIdReducerState } from '../types';

const isReverseDocument = (documentId: number): boolean => {
  if (!documentId) return false;

  if (
    [IDocumentUsaTypeId.PASSPORT, IDocumentUsaTypeId.PERSONAL_ID].includes(
      documentId
    )
  )
    return false;

  if ([IDocumentUsaTypeId.PERSONAL_ID_BACK].includes(documentId)) return true;

  return false;
};

const filterValidDocuments = (
  documents: IOnboardingDocuments[]
): IOnboardingDocuments[] =>
  documents.filter((document) =>
    Object.values(OnboardingUsaDocumentTypeIds).includes(
      document.document.type?.id
    )
  );

const getEmptyDocumentsState = (): GovermentIdReducerState => ({
  documentOne: null,
  documentTwo: null,
});

const getSingleDocumentState = (
  document: IOnboardingDocuments
): GovermentIdReducerState => {
  const isReverse = isReverseDocument(document.document.type?.id);
  return {
    documentOne: !isReverse ? document : null,
    documentTwo: isReverse ? document : null,
  };
};

const getMultipleDocumentsState = (
  documents: IOnboardingDocuments[]
): GovermentIdReducerState => {
  const [firstDoc, secondDoc] = documents;
  const documentReverse = isReverseDocument(secondDoc.document.type?.id)
    ? secondDoc
    : firstDoc;
  const documentNormal = isReverseDocument(firstDoc.document.type?.id)
    ? secondDoc
    : firstDoc;

  return {
    documentOne: documentNormal,
    documentTwo: documentReverse,
  };
};

export {
  isReverseDocument,
  filterValidDocuments,
  getEmptyDocumentsState,
  getSingleDocumentState,
  getMultipleDocumentsState,
};
